import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  BooleanInput,
  // ReferenceArrayInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import ResourcePermissionInput from '../components/inputs/ResourcePermissionInput';
// import SelectArrayInput from '../components/inputs/SelectArrayInput';
import { resources } from '../App';

export const RoleList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <EditButton {...props} basePath="/roles" />
      <DeleteButton {...props} basePath="/roles" />
    </Datagrid>
  </List>
);

const RoleTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

const Form = ({ redirect, ...props }) => (
  <SimpleForm {...props} redirect={redirect}>
    <TextInput source="name" />
    {/* <ReferenceArrayInput {...props} filter={{ name: { $ne: props.record.name } }} source="subRoles" reference="roles" allowEmpty>
      <SelectArrayInput
        options={{ fullWidth: true, errorText: 'Empty for *', errorStyle: { color: 'darkslategrey' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
        optionText="name"
        optionValue="_id"
      />
    </ReferenceArrayInput> */}
    <BooleanInput source="organisationManager" />
    <BooleanInput source="translator" />
    <BooleanInput source="priceEditor" />
    <BooleanInput source="priceManager" />
    <ResourcePermissionInput source="resources" resources={resources} />
  </SimpleForm>
);

export const RoleEdit = (props) => (
  <Edit title={<RoleTitle />} {...props}>
    <Form {...props} redirect="list" />
  </Edit>
);

export const RoleCreate = (props) => (
  <Create {...props}>
    <Form {...props} redirect="list" />
  </Create>
);
